import { useContext, useEffect, useState } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  Step,
  StepLabel,
  Stepper,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { ArrowDropDown, ArrowRight } from '@mui/icons-material';
import { TreeView } from '@mui/x-tree-view/TreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { DropsContext } from 'contexts/DropsContext';
import { ProdutosShopeeContext } from 'contexts/ProdutosShopeeContext';
import { toastWarning } from 'utils/toast';
import Card from 'components/Card';
import Input from 'components/Input';
import Loader from 'components/Loader';
import Header from 'components/Header';
import Button from 'components/Button';
import Dropdown from 'components/Dropdown';
import Container from 'components/Container';
import InputMask from 'components/InputMask';
import VirtualDrop from 'components/VirtualDrop';
import styles from './styles';

const Manutenção = () => {
  const steps = [
    'Identificar Produto',
    'Selecionar Imagens',
    'Escolher Categoria',
    'Selecionar Marca',
    'Adicionais',
    'Envio',
  ];
  const defaultValues = {
    produto_id: null,
    images: [],
    category_id: null,
    marca: null,
    is_mandatory: false,
    adicionais: {},
    envios: [],
  };
  const navigate = useNavigate();
  const [tab, setTab] = useState(0);
  const [categorias, setCategorias] = useState([]);
  const [imagens, setImagens] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [atributos, setAtributos] = useState([]);
  const [envios, setEnvios] = useState([]);
  const { id } = useParams();
  const { drops } = useContext(DropsContext);
  const {
    getImgCategorias,
    getMarcas,
    getEnvios,
    getLoading,
    postAnuncio,
    postLoading,
  } = useContext(ProdutosShopeeContext);
  const { control, handleSubmit, setValue, watch, getValues } = useForm({
    defaultValues,
  });
  const listCols = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  useEffect(() => {
    if (Boolean(id)) {
      setValue('produto_id', id);
      setTab(1);
    }
  }, []);

  useEffect(() => {
    if (tab === 0) {
      setValue('images', []);
    }
    if (tab === 1) {
      const { produto_id } = getValues();
      setValue('category_id', null);
      getImgCategorias({
        params: { produto_id },
        cb: (data) => {
          setImagens(data?.imagens || []);
          setCategorias(data?.categorias || []);
        },
      });
    }
    if (tab === 2) {
      setValue('marca', null);
      setValue('is_mandatory', false);
    }
    if (tab === 3) {
      setValue('adicionais', {});
      loadMarcas();
    }
    if (tab === 4) {
      setValue('envios', []);
      const { category_id } = getValues();
      const params = { category_id };
      getEnvios({
        params,
        cb: (res) => {
          setAtributos(res?.atributos || []);
          setEnvios(res?.formasEnvio || []);
        },
      });
    }
    if (tab === 5) {
    }
  }, [tab]);

  const loadMarcas = () => {
    const { category_id } = getValues();
    const params = { category_id };
    getMarcas({
      params,
      cb: (data) => {
        setMarcas(data?.brand_list || []);
        setValue('is_mandatory', data?.is_mandatory);
      },
    });
  };

  const onSubmit = (values) => {
    if (tab === 0) {
      if (Boolean(values?.produto_id)) {
        setTab(1);
      } else {
        toastWarning('Produto obrigatório');
      }
    }
    if (tab === 1) {
      if (Boolean(values?.images?.length)) {
        setTab(2);
      } else {
        toastWarning('Selecione ao menos uma imagem');
      }
    }
    if (tab === 2) {
      if (Boolean(values?.category_id)) {
        setTab(3);
      } else {
        toastWarning('Selecione uma categoria');
      }
    }
    if (tab === 3) {
      if (Boolean(values?.is_mandatory) && !Boolean(values?.marca)) {
        toastWarning('Selecione uma marca');
      } else {
        setTab(4);
      }
    }
    if (tab === 4) {
      //fazer validações dos campos
      setTab(5);
    }
    if (tab === 5) {
      if (!Boolean(values?.envios?.length)) {
        return toastWarning('Selecione uma forma de envio');
      }
      const brand = marcas?.find((f) => f?.brand_id === values?.marca);
      const attribute_list = Object.entries(values?.adicionais).map(
        ([key, value]) => {
          const attribute_value_list = [];
          if (Array.isArray(value?.value_id) && value?.value_id?.length) {
            value?.value_id?.map((v) => {
              attribute_value_list?.push({
                value_id: v || 0,
                ...(Boolean(value?.value_unit) && {
                  value_unit: value?.value_unit,
                }),
                ...(Boolean(value?.original_name_value) && {
                  original_name_value: value?.original_name_value,
                }),
              });
            });
          } else if (
            Boolean(value?.original_value_name) ||
            Boolean(value?.value_id)
          ) {
            attribute_value_list?.push({
              value_id: value?.value_id || 0,
              ...(Boolean(value?.value_unit) && {
                value_unit: value?.value_unit,
              }),
              ...(Boolean(value?.original_name_value) && {
                original_name_value: value?.original_name_value,
              }),
            });
          }
          return { attribute_id: Number(key), attribute_value_list };
        }
      );

      const data = {
        produto_id: values?.produto_id,
        category_id: values?.category_id,
        imagens: values?.images,
        brand,
        logistic_info: values?.envios,
        attribute_list,
      };
      postAnuncio({ data, cb: () => navigate(-1) });
    }
  };

  const renderTree = (nodes) => (
    <TreeItem
      key={`${nodes?.category_id}`}
      nodeId={`${nodes?.category_id}`}
      label={
        <Box sx={styles?.categoryBox}>
          {(!Array.isArray(nodes?.children) || !nodes?.children?.length) && (
            <Checkbox
              size="small"
              checked={nodes?.category_id === watch('category_id')}
              onChange={(_, v) => {
                if (v) {
                  setValue('category_id', nodes?.category_id);
                } else {
                  setValue('category_id', null);
                }
              }}
            />
          )}
          <Typography sx={styles?.category}>
            {nodes?.display_category_name}
          </Typography>
        </Box>
      }
    >
      {Array.isArray(nodes?.children) ? nodes?.children?.map(renderTree) : null}
    </TreeItem>
  );

  const RenderInputs = ({ input }) => {
    if ([1, 2]?.includes(input?.attribute_info?.input_type)) {
      return (
        <Grid item xs={12} display="flex" alignItems="center" gap={2}>
          <Box flex={3}>
            <Dropdown
              control={control}
              label={input?.label}
              options={input?.values}
              name={`adicionais.${input?.attribute_id}.value_id`}
            />
          </Box>
          {input?.attribute_info?.format_type === 2 && (
            <Box flex={1}>
              <Dropdown
                label="Unidade"
                control={control}
                name={`adicionais.${input?.attribute_id}.value_unit`}
                options={input?.attribute_info?.attribute_unit_list?.map(
                  (v) => ({
                    value: v,
                    label: v,
                  })
                )}
              />
            </Box>
          )}
        </Grid>
      );
    }
    if (input?.attribute_info?.input_type === 3) {
      return (
        <Grid item xs={12} display="flex" alignItems="center" gap={2}>
          <Box flex={3}>
            <Input
              control={control}
              label={input?.label}
              name={`adicionais.${input?.attribute_id}.original_value_name`}
            />
          </Box>
          {input?.attribute_info?.format_type === 2 && (
            <Box flex={1}>
              <Dropdown
                label="Unidade"
                control={control}
                name={`adicionais.${input?.attribute_id}.value_unit`}
                options={input?.attribute_info?.attribute_unit_list?.map(
                  (v) => ({
                    value: v,
                    label: v,
                  })
                )}
              />
            </Box>
          )}
        </Grid>
      );
    }
    if ([4, 5]?.includes(input?.attribute_info?.input_type)) {
      return (
        <Grid item xs={12} display="flex" alignItems="center" gap={2}>
          <Box flex={3}>
            <Dropdown
              multiple
              control={control}
              label={input?.label}
              options={input?.values}
              name={`adicionais.${input?.attribute_id}.value_id`}
            />
          </Box>
          {input?.attribute_info?.format_type === 2 && (
            <Box flex={1}>
              <Dropdown
                label="Unidade"
                control={control}
                name={`adicionais.${input?.attribute_id}.value_unit`}
                options={input?.attribute_info?.attribute_unit_list?.map(
                  (v) => ({
                    value: v,
                    label: v,
                  })
                )}
              />
            </Box>
          )}
        </Grid>
      );
    }
    return null;
  };

  const RenderEnvios = ({ envio, index }) => {
    const envios = watch('envios') || [];
    const checked = envios?.some(
      (s) => s?.logistic_id === envio?.logistics_channel_id
    );

    const onChange = () => {
      if (checked) {
        setValue(
          'envios',
          envios?.filter((f) => f?.logistic_id !== envio?.logistics_channel_id)
        );
      } else {
        setValue('envios', [
          ...envios,
          { logistic_id: envio?.logistics_channel_id, is_free: false },
        ]);
      }
    };

    const updateEnvioField = (logistic_id, field, value) => {
      const updated = envios?.map((item) =>
        item?.logistic_id === logistic_id ? { ...item, [field]: value } : item
      );
      setValue('envios', updated);
    };

    const current = envios?.find(
      (e) => e?.logistic_id === envio?.logistics_channel_id
    );

    return (
      <Accordion expanded={checked}>
        <AccordionSummary>
          <Box>
            <FormControlLabel
              label={
                <Typography fontWeight="bold">
                  {envio?.logistics_channel_name}
                </Typography>
              }
              control={
                <Checkbox checked={checked} onChange={onChange} size="small" />
              }
            />
            <Typography
              variant="caption"
              component="div"
              dangerouslySetInnerHTML={{
                __html: envio?.logistics_description || '',
              }}
            />
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          {checked && (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormControlLabel
                  label="Frete grátis"
                  control={
                    <Checkbox
                      size="small"
                      checked={current?.is_free || false}
                      onChange={(_, v) =>
                        updateEnvioField(
                          envio?.logistics_channel_id,
                          'is_free',
                          v
                        )
                      }
                    />
                  }
                />
              </Grid>
              {envio?.fee_type === 'SIZE_SELECTION' && (
                <Grid item xs={12}>
                  <Dropdown
                    label="Tamanho"
                    control={control}
                    name={`envios[${index}].size_id`}
                    options={envio?.size_list?.map((s) => ({
                      value: s?.size_id,
                      label: s?.default_name,
                      Preço: (s?.default_price || 0)?.toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                      }),
                    }))}
                  />
                </Grid>
              )}
              {envio?.fee_type === 'CUSTOM_PRICE' && (
                <Grid item xs={12}>
                  <InputMask
                    label="Preço"
                    control={control}
                    name={`envios[${index}].shipping_fee`}
                  />
                </Grid>
              )}
            </Grid>
          )}
        </AccordionDetails>
      </Accordion>
    );
  };

  return (
    <Container>
      <Header titulo="Cadastrar Anúncio" />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Card>
            <Stepper activeStep={tab} alternativeLabel>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
          </Card>
        </Grid>
        <Grid item xs={12} display={tab === 0 ? 'block' : 'none'}>
          <Card title="Identificar Produto">
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <VirtualDrop
                  name="produto_id"
                  control={control}
                  label="Produto"
                  options={drops?.Produto}
                  disabled={Boolean(id)}
                />
              </Grid>
              <Grid item xs={12} textAlign="end">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit(onSubmit)}
                >
                  Próximo
                </Button>
              </Grid>
            </Grid>
          </Card>
        </Grid>
        <Grid item xs={12} display={tab === 1 ? 'block' : 'none'}>
          {getLoading ? (
            <Loader />
          ) : (
            <Card title="Selecionar Imagens">
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <ImageList cols={listCols ? 2 : 5} gap={10}>
                    {imagens?.map((item) => {
                      const checked = watch('images')?.some(
                        (s) => s?.id === item?.id
                      );
                      return (
                        <ImageListItem key={item.url}>
                          <Box
                            component="img"
                            sx={styles?.image}
                            srcSet={`${item.url}?fit=crop&auto=format&dpr=2 2x`}
                            src={`${item.url}?fit=crop&auto=format`}
                            loading="lazy"
                          />
                          <ImageListItemBar
                            sx={styles?.bar}
                            position="top"
                            actionIcon={
                              <Checkbox
                                checked={checked}
                                sx={styles?.checkbox}
                                onChange={(_, v) => {
                                  let arr = [...watch('images')];
                                  if (v) {
                                    arr = [...arr, item];
                                  } else {
                                    arr = arr?.filter(
                                      (f) => f?.id !== item?.id
                                    );
                                  }
                                  setValue('images', arr);
                                }}
                              />
                            }
                            actionPosition="left"
                          />
                        </ImageListItem>
                      );
                    })}
                  </ImageList>
                </Grid>
                <Grid
                  item
                  xs={12}
                  display="flex"
                  justifyContent="space-between"
                >
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => setTab(0)}
                  >
                    Voltar
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit(onSubmit)}
                  >
                    Próximo
                  </Button>
                </Grid>
              </Grid>
            </Card>
          )}
        </Grid>
        <Grid item xs={12} display={tab === 2 ? 'block' : 'none'}>
          {getLoading ? (
            <Loader />
          ) : (
            <Card title="Escolher Categoria">
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TreeView
                    defaultCollapseIcon={<ArrowDropDown />}
                    defaultExpandIcon={<ArrowRight />}
                  >
                    {categorias?.map(renderTree)}
                  </TreeView>
                </Grid>
                <Grid
                  item
                  xs={12}
                  display="flex"
                  justifyContent="space-between"
                >
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => setTab(1)}
                  >
                    Voltar
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit(onSubmit)}
                  >
                    Próximo
                  </Button>
                </Grid>
              </Grid>
            </Card>
          )}
        </Grid>
        <Grid item xs={12} display={tab === 3 ? 'block' : 'none'}>
          {getLoading ? (
            <Loader />
          ) : (
            <Card title="Selecionar Marca">
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <VirtualDrop
                    name="marca"
                    control={control}
                    label="Marca"
                    options={marcas?.map((m) => ({
                      label: m?.display_brand_name,
                      value: m?.brand_id,
                    }))}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  display="flex"
                  justifyContent="space-between"
                >
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => setTab(2)}
                  >
                    Voltar
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit(onSubmit)}
                  >
                    Próximo
                  </Button>
                </Grid>
              </Grid>
            </Card>
          )}
        </Grid>
        <Grid item xs={12} display={tab === 4 ? 'block' : 'none'}>
          <Card title="Adicionais">
            {getLoading ? (
              <Loader />
            ) : (
              <Grid container spacing={2}>
                {atributos?.map((a, i) => (
                  <RenderInputs key={i?.toString()} input={a} />
                ))}
                <Grid
                  item
                  xs={12}
                  display="flex"
                  justifyContent="space-between"
                >
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => setTab(3)}
                  >
                    Voltar
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit(onSubmit)}
                  >
                    Próximo
                  </Button>
                </Grid>
              </Grid>
            )}
          </Card>
        </Grid>
        <Grid item xs={12} display={tab === 5 ? 'block' : 'none'}>
          <Card title="Envio">
            <Grid container spacing={2}>
              <Grid item xs={12}>
                {envios?.map((e, i) => (
                  <RenderEnvios key={i?.toString()} envio={e} index={i} />
                ))}
              </Grid>
              <Grid item xs={12} display="flex" justifyContent="space-between">
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => setTab(4)}
                >
                  Voltar
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  loading={postLoading}
                  onClick={handleSubmit(onSubmit)}
                >
                  Concluir
                </Button>
              </Grid>
            </Grid>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Manutenção;
